/**
 * View component for /my-agenda
 *
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, NavLink, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import actions
import * as sponsorActions from '../../sponsor/sponsorActions';
import * as contentModuleActions from '../../contentModule/contentModuleActions';
import * as moduleCertificateActions from '../../moduleCertificate/moduleCertificateActions';

// import global components
import Base from '../../../global/components/BaseComponent.js.jsx';

// import module components
import AgendaStatusAlerts from '../components/AgendaStatusAlerts.js.jsx';
import StudyLayout from '../../study/components/StudyLayout.js.jsx';
import SponsorAgendaManager from '../components/SponsorAgendaManager.js.jsx';

import _ from 'lodash';
// not updating links here because this should no longer be used with london handling agenda

class MyAgenda extends Base {
  constructor(props) {
    super(props);
    this.state = {
      queryText: ''
      , numShowingPharma: 10
      , numShowingNonPharma: 10
    }
    this._bind(
      '_handleQuery'
    )
  }

  componentDidMount() {

    // redirect to london
    window.location.replace(`${window.agendaUrl}/agenda`);

    const { loggedInUser, dispatch } = this.props;
    dispatch(sponsorActions.fetchListIfNeeded('user', loggedInUser._id));   
    dispatch(moduleCertificateActions.fetchListIfNeeded('_user', loggedInUser._id)).then((action) => {
      let cmIds = action.list.map(item => item._contentModule);
      this.setState({cmIds});
      dispatch(contentModuleActions.fetchListIfNeeded('_id', cmIds));
    });
  }

  _handleQuery(e) {
    this.setState({
      [e.target.name]: e.target.value.toLowerCase()
    });
  }

  render() {
    const {
      loggedInUser
      , sponsorStore
      , moduleCertificateStore
    } = this.props;

    const {
      numShowingNonPharma
      , numShowingPharma
    } = this.state;

    const sponsorList = loggedInUser && sponsorStore.lists.user ? sponsorStore.lists.user[loggedInUser._id] : {};
    const sponsors = sponsorStore.util.getList('user', loggedInUser._id);

    const sponsorsEmpty = (
      !sponsors || sponsors.length == 0
    )

    const sponsorsFetching = (
      !sponsorList 
      || sponsorList.isFetching
    )

    let pharmaTraining = sponsors ? sponsors.filter(s => s.type === 'pharma') : [];
    // console.log('pharmaTraining', pharmaTraining)
    let nonPharmaTraining = sponsors ? sponsors.filter(s => s.type !== 'pharma') : [];
    // console.log('nonPharmaTraining', nonPharmaTraining)

    /**
     * use the reducer getList utility to convert the all.items array of ids
     * to the actual moduleCertificate objetcs
     */
    const moduleCertificates = moduleCertificateStore.util.getList('_user', loggedInUser._id) || [];

    return (
      <StudyLayout>
        <Helmet
          title={"My Agenda | Pro-ficiency"}
        />
        <div className="flex">
          <section className="section my-agenda">
            {/* <div className="-content-wrapper"> */}
            <div>
              <div className="-header" style={{marginBottom: 10}}>
                <h2>
                  <i className="fa-regular fa-graduation-cap fa-sm" style={{paddingRight: 10}}></i>
                  Training
                </h2>
                {!sponsorsEmpty ? 
                  <Link to="/my-certificates" className="yt-btn small secondary">View All Completed Training</Link>
                : null
                }
              </div>
              { loggedInUser && loggedInUser.username ?
                <div className="yt-row" style={{marginBottom: '20px', marginTop: '20px'}}>
                  <div className="-tab-wrapper">
                    <NavLink to="/my-agenda" exact={true} className={`-tab-btn active`}>My Agenda</NavLink>
                  </div>
                  <div className="-tab-wrapper" style={{position: 'relative'}}>
                    <NavLink to="/my-certificates" className={`-tab-btn`}>Certificates</NavLink>
                    { sponsorsEmpty ?
                      null 
                      :
                      <AgendaStatusAlerts/>
                    }
                  </div>
                </div>
                :
                null
              }
              { sponsorsEmpty ?
                (sponsorsFetching ?
                  <div className="u-centerText">
                    <div className="loading"></div>
                  </div>
                :
                  <div className="-welcome-wrapper">
                    <div className="u-centerText">
                      <h2 style={{marginTop: 100}}>Welcome to Pro-ficiency!</h2>
                      <div style={{marginTop: 30}}>
                        <p>You aren't enrolled in any programs yet.</p>
                        {/* <p>Feel free to join the waiting list for some upcoming studies.</p> */}
                        <p>Please <Link to="/contact-us">contact</Link> your administrator if you feel this was an error.</p>
                        {/* <p>Or browse the catalog of our public training courses below.</p> */}
                      </div>
                      {/* <div style={{marginTop: 40}}>
                        <button className="yt-btn primary" onClick={null}>Join wait list</button>
                      </div> */}
                    </div>
                  </div>
                )
                : 
                <div style={{ opacity: sponsorsFetching ? 0.5 : 1 }}>
                  { pharmaTraining.length > 0 ? 
                    <div>
                      <div className="-sponsored-training">
                        <div className="-agenda-section">
                          { pharmaTraining.sort((a,b) => a.orderWeight - b.orderWeight).slice(0, this.state.numShowingPharma).map((sponsor, i) => 
                            <SponsorAgendaManager
                              key={'grouped_' + sponsor._id + '_' + i}
                              sponsor={sponsor}
                            />                        
                          )}
                        </div>
                        {pharmaTraining.length > numShowingPharma ? 
                          <div className="-study-wrapper">
                            <button className="yt-btn block link" onClick={() => this.setState({numShowingPharma: numShowingPharma + 10})}>Show more sponsored programs</button>
                          </div>
                          :
                          null 
                        }
                      </div>
                    </div>
                    : 
                    null
                  }
                  { nonPharmaTraining.length > 0 ?
                    <div>
                      <div className="-training">Additional Training</div>
                      <div className="-non-sponsored-training">
                        <div className="-agenda-section">
                          { nonPharmaTraining.sort((a,b) => a.orderWeight - b.orderWeight).slice(0, this.state.numShowingNonPharma).map((sponsor, i) => 
                            <SponsorAgendaManager
                              key={'grouped_' + sponsor._id + '_' + i}
                              sponsor={sponsor}
                            />                        
                          )}
                        </div>
                        {nonPharmaTraining.length > numShowingNonPharma ? 
                          <div className="-study-wrapper">
                            <button className="yt-btn block link" onClick={() => this.setState({numShowingNonPharma: numShowingNonPharma + 10})}>Show more available programs</button>
                          </div>
                          :
                          null 
                        }
                      </div>
                    </div>
                    : null
                  }
                </div>
              }
            </div>
          </section>
        </div>
      </StudyLayout>
    )
  }
}


MyAgenda.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    loggedInUser: store.user.loggedIn.user
    , sponsorStore: store.sponsor
    , contentModuleStore: store.contentModule 
    , moduleCertificateStore: store.moduleCertificate
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(MyAgenda)
);



// WEBPACK FOOTER //
// modules/agenda/views/MyAgenda.js.jsx